import styled, { css } from 'styled-components';
import mediaQueries from '@Utils/shared/constants/mediaQueries';
import ColumnThin from '@Utils/shared/components/Icons-v3/ColumnThin';

export const DropDown = styled.div`
  display: flex;
  position: relative;
  height: 100%;
  align-self: center;

  @media ${mediaQueries.mobile} {
    margin-top: 14px;
  }

  @media ${mediaQueries.tablet} {
    width: 100%;
    margin-top: 30px
  }


`;

export const DropContainer = styled.div<{ isVisible: boolean }>`
  position: absolute;
  z-index: 500;
  top: 100%;
  right: 0;
  margin-top: 10px;
  width: max-content;
  padding: 0 0 20px;
  border-radius: 6px;
  box-shadow: 0 10px 30px -5px rgba(0, 0, 0, 0.4);
  background-color: #3e3f49;
  display: ${(props) => (props.isVisible ? 'flex' : 'none')};
  flex-direction: column;
`;

export const DropdownMobileContainer = styled.div`
  width: calc(100% - 60px);
  margin: 0 auto;
  padding: 0 0 20px;
  border-radius: 6px;
  box-shadow: 0 10px 30px -5px rgba(0, 0, 0, 0.4);
  background-color: #3e3f49;
  display: flex;
  flex-direction: column;

  @media ${mediaQueries.tablet} {
    max-width: 600px;
  }
`;

export const ColumnIcon = styled(ColumnThin)`
  display: flex;
  width: 20px;
  height: 20px;
  margin-left: 5px;
`;

export const DropDownValue = styled.div<{ isActive: boolean }>`
  display: flex;
  width: fit-content;
  padding: 6px 6px 6px 8px;
  border-radius: 6px;
  background-color: #3e3f49;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;

  &:hover {
    background-color: #494a56;
  }

  ${(props) =>
    props.isActive &&
    css`
      background-color: #1a1b1f;
    `}

  @media ${mediaQueries.tablet} {
    height: 40px;
    padding: 10px 10px 10px 15px;
    font-size: 16px;
    width: 100%;
    justify-content: space-between;
  }
`;

export const DropHeader = styled.div`
  display: flex;
  justify-content: space-between;
  height: 45px;
  margin: 0 0 30px;
  padding: 10px 15px;
  border-radius: 6px;
  background-color: #363740;

  @media ${mediaQueries.mobileOrTablet} {
    padding: 10px 10px 10px 15px;
  }
`;

export const DropTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 25px;
  color: var(--bg-white);
  text-align: left;
`;

export const ClosePopup = styled.button`
  display: flex;
  background: transparent;
  border: none;
  width: 25px;
  height: 25px;
  align-self: center;
  cursor: pointer;
`;

export const DropList = styled.div`
  padding: 0 35px;
  column-count: 2;
  column-fill: balance;

  @media ${mediaQueries.mobile} {
    padding: 0 20px;
    column-count: 1;
  }
`;

export const DropItem = styled('a')<{ isActive: boolean }>`
  display: flex;
  width: 100%;
  max-width: 200px;
  font-size: 16px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.8);
  padding-bottom: 20px;
  cursor: pointer;
  page-break-inside: avoid;
  break-inside: avoid;

  ${(props) =>
    props.isActive &&
    css`
      color: rgba(255, 255, 255, 0.5);
    `}

  &:hover {
    color: rgba(255, 255, 255, 0.5);
  }
`;

export const HiddenMenuSSRMobile = styled.div`
  position: absolute;
  left: -9999px;
  opacity: 0;
`;
